namespace GeniuzPOS.Inventory {
    export class IcStockDisassembleColumns {
        static columnsKey = 'Inventory.IcStockDisassemble';
    }
}
